import { defineStore } from 'pinia'
import { type SectionItem, type TeamMember, type ManagerData } from '~/types'
import { useAuthFetch } from '~/composables/useAuthFetch'
import { ProductType } from '~/types/product'

export const useManagerStore = defineStore('manager', () => {
  // @ts-ignore
  const sections = ref([])
  const promos = ref([])
  const offers = ref([])
  const courses = ref([])
  const opinions = ref([])
  const team = ref([])
  const managerData = ref(null)
  const { $i18n } = useNuxtApp()
  function fetchSections() {
    const headers = new Headers()
    const currentLocale = $i18n.locale.value
    const { accessToken }: any = storeToRefs(useAuthStore())

    headers.append('Accept-Language', currentLocale)
    headers.append('Authorization',  `Bearer ${accessToken.value}`,)
    return new Promise((resolve, reject) => {
      useAuthFetch(`/managers/sections`, {
        headers,
        onResponse({ response }) {
          if (response._data) {
            const { userInfo }: any = storeToRefs(useUserStore())

            sections.value = (response._data as Array<Object>).map(
              (section: any) => {
                const isSectionActive = userInfo.value.sections
                  ? userInfo.value.sections.find(s => s.id === section.id)
                      ?.isActive
                  : false

                console.log(section, isSectionActive)

                return {
                  ...section,
                  isActive: isSectionActive,
                }
              }
            ) as Array<Object>

            resolve(sections.value)
          }
        },
        onResponseError({ response }) {
          reject(response)
        },
      })
    })
  }
  function updateProfileInfo({ data }: { data: ManagerData }) {
    managerData.value = data
  }
  function updateProfileImage(newImage: string) {
    managerData.value.image = newImage
  }
  async function toggleSection(sectionId: number) {
    const { userId } = storeToRefs(useAuthStore())

    const itemId = sections.value.findIndex(
      (i: SectionItem) => i.id === sectionId
    )
    sections.value[itemId].isActive = !sections.value[itemId].isActive

    const response = await useAuthFetch(`/managers/${userId.value}/section`, {
      method: 'PUT',
      body: {
        sectionId,
        isActive: sections.value[itemId].isActive,
      },
    })
  }
  function updateValue({
    id,
    type,
    key,
    value,
  }: {
    id: number | null
    type: string
    key: string
    value: any
  }) {
    return false
    /*  // @ts-ignore
      const itemId = (this[type] as any).findIndex(o => o.id === id)

      if (itemId < 0 && type in this) {
        ;(this as any)[type].push({
          id: (this as any)[type].length + 1,
          image: '',
          person: '',
          company: '',
          price: 0,
          isActive: false,
          date: '12 LIPIEC 2023',
          title: '',
          description: '',
          type: 'offers',
        })
        this.updateValue({ id, type, key, value })
        return
      }

      if (type in this) {
        ;(this as any)[type][itemId][key] = value
      } else {
        console.error(`Invalid type: ${type}`)
      }*/
  }
  function removeItem({ id, type }: { id: number | null; type: string }) {
    /*const itemId = type.findIndex((o: Product) => o.id === id)
      delete type.value[itemId]*/
  }

  const getActiveSections = computed((): SectionItem[] => {
    return sections.value.filter((s: SectionItem) => s.isActive)
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getProduct = computed(({ id, type }: any) => {
    console.log(id, type)
    /* const itemId = (this as any)[type].findIndex((o: Product) => o.id === id)
      return (this as any)[type][itemId]*/

    return null
  })
  const getAllMembers = computed((): TeamMember[] => {
    const { userInfo }: any = storeToRefs(useUserStore())

    return userInfo.value.team as TeamMember[]
  })
  const getManagerData = computed((): ManagerData => {
    return managerData.value
  })

  return {
    sections,
    promos,
    offers,
    courses,
    opinions,
    team,
    managerData,
    fetchSections,
    updateProfileInfo,
    updateProfileImage,
    toggleSection,
    updateValue,
    removeItem,
    getActiveSections,
    getProduct,
    getAllMembers,
    getManagerData,
  }
})
